// Static URLs for candy logos (served from public/images/candies/)
// These URLs are predictable and can be used outside of React

const CANDIES_BASE_PATH = '/images/candies';

export const CANDY_LOGOS = {
    cocoapop: {
        Street: `${CANDIES_BASE_PATH}/cocoapop_street.jpg`,
        Juiced: `${CANDIES_BASE_PATH}/cocoapop_juiced.jpg`,
        Cracked: `${CANDIES_BASE_PATH}/cocoapop_cracked.jpg`,
        Unhinged: `${CANDIES_BASE_PATH}/cocoapop_unhinged.jpg`,
        GoldMember: `${CANDIES_BASE_PATH}/cocoapop_goldmember.jpg`,
        MythDck: `${CANDIES_BASE_PATH}/cocoapop_mythdck.jpg`,
    },
    slaptaffy: {
        Street: `${CANDIES_BASE_PATH}/slaptaffy_street.jpg`,
        Juiced: `${CANDIES_BASE_PATH}/slaptaffy_juiced.png`,
        Cracked: `${CANDIES_BASE_PATH}/slaptaffy_cracked.jpg`,
        Unhinged: `${CANDIES_BASE_PATH}/slaptaffy_unhinged.jpg`,
        GoldMember: `${CANDIES_BASE_PATH}/slaptaffy_goldmember.jpg`,
        MythDck: `${CANDIES_BASE_PATH}/slaptaffy_mythdck.jpg`,
    },
    nutpop: {
        Street: `${CANDIES_BASE_PATH}/nutpop_street.jpg`,
        Juiced: `${CANDIES_BASE_PATH}/nutpop_juiced.jpg`,
        Cracked: `${CANDIES_BASE_PATH}/nutpop_cracked.jpg`,
        Unhinged: `${CANDIES_BASE_PATH}/nutpop_unhinged.jpg`,
        GoldMember: `${CANDIES_BASE_PATH}/nutpop_goldmember.jpg`,
        MythDck: `${CANDIES_BASE_PATH}/nutpop_mythdck.jpg`,
    },
    shaftberry: {
        Street: `${CANDIES_BASE_PATH}/shaftberry_street.png`,
        Juiced: `${CANDIES_BASE_PATH}/shaftberry_juiced.jpg`,
        Cracked: `${CANDIES_BASE_PATH}/shaftberry_cracked.jpg`,
        Unhinged: `${CANDIES_BASE_PATH}/shaftberry_unhinged.jpg`,
        GoldMember: `${CANDIES_BASE_PATH}/shaftberry_goldmember.jpg`,
        MythDck: `${CANDIES_BASE_PATH}/shaftberry_mythdck.jpg`,
    },
};

const getFirstLogo = (logoSet) => {
    if (!logoSet) return null;
    return logoSet.Street || Object.values(logoSet)[0] || null;
};

export const getCandyLogo = (candyId, version) => {
    const logoSet = CANDY_LOGOS[candyId];
    if (!logoSet) return null;
    return logoSet[version] || null;
};

export const getCandyBaseLogo = (candyId) => {
    const logoSet = CANDY_LOGOS[candyId];
    return getFirstLogo(logoSet);
};

export default {
    CANDY_LOGOS,
    getCandyLogo,
    getCandyBaseLogo,
};
